export const serviceResponse = `
    status,
    error,
    message,
`;
